import React from "react";
import Carousel from "react-native-reanimated-carousel";
import { PressableWrap } from "../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import ImageWithAspectRatio from "../../Universal/Image/ImageWithAspectRatio";
import { useAppContext } from "../../Universal/API/Context-API/AppContext";
import { useSmartNavigate } from "../../Universal/API/Context-API/hooks/useSmartNavigate";

export interface HomeBannerSlide {
  image: string;
  collectionName: string;
}

interface HomeBannerCarouselProps {
  navigation: any;
  slides: HomeBannerSlide[];
  autoPlay?: boolean;
  aspectRatio?: number
}

const BANNER_ASPECT_RATIO = 1920 / 540;

const HomeBannerCarousel: React.FC<HomeBannerCarouselProps> = ({
  navigation,
  slides,
  autoPlay = true,
  aspectRatio
}) => {
  const { currentWidth } = useAppContext();
  const { smartNavigate } = useSmartNavigate({ navigation });

  const bannerWidth = currentWidth || 1200;
  const bannerHeight = bannerWidth / (aspectRatio ?? BANNER_ASPECT_RATIO);

  return (
    <Carousel
      width={bannerWidth}
      height={bannerHeight}
      data={slides}
      loop
      autoPlay={autoPlay}
      autoPlayInterval={5000}
      scrollAnimationDuration={900}
      pagingEnabled
      snapEnabled
      renderItem={({ item }) => (
        <PressableWrap
          activeOpacity={0.96}
          onPress={() => {
            smartNavigate({
              navigation,
              goTo: "Collection",
              data: { collection_name: item.collectionName },
            });
          }}
        >
          <ImageWithAspectRatio
            aspectRatio={BANNER_ASPECT_RATIO}
            minWidth={bannerWidth}
            source={{
              uri: item.image,
              priority: "high",
            }}
          />
        </PressableWrap>
      )}
    />
  );
};

export default React.memo(HomeBannerCarousel);
